/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import notifications from 'notifications';
import {DropdownSearchType} from 'search/SearchConstants';
import AbsoluteDropdownContainer from 'ui-library/AbsoluteDropdownContainer';
import SearchDropdown from 'ui-library/attach-dropdown/SearchDropdown';
import {DEFAULT_DROPDOWN_SEARCH_LIMIT} from 'ui-library/dropdowns/SearchDropdownConstants';
import * as keyboard from 'util/Keyboard';

interface Props {
  allowEmptyQuery?: boolean;
  onCancel: (...args: Array<any>) => any;
  onCreateSearchPromise: (...args: Array<any>) => any;
  searchEndpoint: string;
  onSelectItem: (...args: Array<any>) => any;
  onSetQueryText: (...args: Array<any>) => any;
  queryText: string;
}

/**
 * A table cell that provides a search input. Note that if this component is rendered, it is assumed
 * that it has focus; for example, it keeps focus on the search input and the dropdown is always
 * visible.
 */
class SearchCell extends React.Component<Props> {
  searchInputRef = React.createRef<HTMLInputElement>();
  dropdownRef = React.createRef<SearchDropdown>();

  componentDidMount(): void {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  }

  componentDidUpdate(): void {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.focus();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleClickOut = () => {
    this.props.onCancel();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleSearch = (query: any, searchResultsCallback: any) => {
    this.props
      .onCreateSearchPromise(query)
      .then((results: any) => {
        searchResultsCallback({query, limit: DEFAULT_DROPDOWN_SEARCH_LIMIT, results, errorMessage: null});
      })
      .catch((resp: any) => {
        const errorMessage = notifications.getFriendlyError(resp) || 'An error occurred.';
        searchResultsCallback({query, limit: DEFAULT_DROPDOWN_SEARCH_LIMIT, results: [], errorMessage});
      });
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleSelect = (id: any, name: any, url: any, selectedItem: any) => {
    this.props.onSelectItem(selectedItem);
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _handleKeyDown = (e: any) => {
    if (keyboard.isEscapeKey(e)) {
      this.props.onCancel();
      e.preventDefault();
      return true;
    }
    if (this.dropdownRef.current) {
      const handled = this.dropdownRef.current.queryKeydownHandler(e);
      return handled;
    }
    return false;
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _renderSearchDropdown = () => (
    <SearchDropdown
      ref={this.dropdownRef}
      profilerTrackingParams={{
        url: this.props.searchEndpoint,
        searchType: DropdownSearchType.ENTITY_LINK,
      }}
      query={this.props.queryText}
      allowEmptyQuery={this.props.allowEmptyQuery}
      doSearch={this._handleSearch}
      selectAttachment={this._handleSelect}
      width="100%"
    />
  );

  render(): JSX.Element {
    return (
      <AbsoluteDropdownContainer
        canDropUnder={true}
        menu={this._renderSearchDropdown()}
        onRequestClose={this._handleClickOut}
        open={true}
      >
        <input
          className="stageEntry-searchCell"
          type="text"
          onKeyDown={this._handleKeyDown}
          onChange={(e) => {
            this.props.onSetQueryText(e.target.value);
          }}
          value={this.props.queryText}
          ref={this.searchInputRef}
        />
      </AbsoluteDropdownContainer>
    );
  }
}

export default SearchCell;
